import { formatName } from '@/utils/Formatter';

import { useUser } from '@/context/UserContext';

import * as S from './style';

const UserProfile = () => {
  const { userInformation } = useUser();
  const {
    first_name = '',
    last_name = '',
    main_role = 'Cargo não disponível',
  } = userInformation || {};

  const fullName =
    `${formatName(first_name)} ${formatName(last_name)}`.trim() || 'Nome não disponível';

  return (
    <S.Wrapper>
      <S.UserName>{fullName}</S.UserName>
      <S.UserRole>{main_role}</S.UserRole>
    </S.Wrapper>
  );
};

export default UserProfile;
